const vFilter={
  //身份证 id  隔断
  id_blank(value) { 
  	if (!value) return '无';
  	let a = value.substring(0,6);
  	let b = value.substring(6,14);
  	let c = value.substring(14,18);
  	let d = a+' '+b+ ' '+ c
  	return d;
  },
	
	//手机号 隔断
	vf_mobile(value){
		if (!value) return '';
		let a = value.substring(0,3);
		let b = value.substring(3,7);
		let c = value.substring(7,11);
		let d = a+' '+b+ ' '+ c
		return d;
	},
  
  //四位一个空格
  sub_blank(value) { 
  	if (!value) return '无';
  	let o = value.replace(/\s/g, '').replace(/(.{4})/g, "$1 ");
  	return o;
  },
  
  // 费率保留两位小数
  rate(val) {
  	if (!val) return ''
  	let obj = (val * 100).toFixed(2);
  	return obj
  },
  
  //保留两位小数
  toFixed2(val){
  	if(!val) return ''; 
  	let num = Number(val).toFixed(2);
  	return num
  },
  
  //过滤金钱加,
  filterNumber(value) { 
  	if(!value) return '0.00';
  	var intPart = Number(value) - Number(value) % 1; //获取整数部分（这里是windy93的方法）
  	var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  	var floatPart = ".00"; //预定义小数部分
  	var value2Array = value.toString().split(".");
  	//=2表示数据有小数位
  	if(value2Array.length == 2) {
  		floatPart = value2Array[1].toString(); //拿到小数部分
  		if(floatPart.length == 1) { //补0,实际上用不着
  			return intPartFormat + "." + floatPart + '0';
  		} else {
  			return intPartFormat + "." + floatPart;
  		}
  	} else {
  		return intPartFormat + floatPart;
  	}
  },
  
	// 有没有数据
  isData(val){
		if(!val) return '无'
		return val;
  },
  
  // 姓名加密
  filterName(val){
  	if(!val) return '';
  	var arr1 = val.split('');
  	let obj = arr1[0];
  	if(arr1[2]){
  		return obj+'* *'
  	}else{
  		return obj+'*'
  	}
  },
  
  // 身份证号 银行卡号加密
  filterCardId(val){
  	if(!val) return '';
  	let obj = val.substr(0 ,12)
  	return obj+'******';
  },
  // 手机号加密
  filterPhone(val){
  	if(!val) return '';
  	let obj = val.substr(0 ,7)
  	return obj+'****';
  }
  
}
 
export default vFilter



// WEBPACK FOOTER //
// ./src/assets/js/filter.js